import { render, staticRenderFns } from "./LinkAttachments.vue?vue&type=template&id=44968e04&"
import script from "./LinkAttachments.vue?vue&type=script&lang=ts&"
export * from "./LinkAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports